/**
 * Group items by a key, preserving first-appearance order of the groups and
 * input order within each.
 *
 * Written once because both places that needed it reached for the same
 * `reduce` over a `Map` with a spread per element — which is a mutable
 * accumulator wearing a fold's clothes, and quadratic in group size besides.
 * The mutation is local to this function and never observable.
 *
 * @returns {Array<[key, items[]]>}
 */
export const groupBy = (items, keyOf) => {
  const groups = new Map();
  (items || []).forEach((item) => {
    const key = keyOf(item);
    const existing = groups.get(key);
    if (existing) existing.push(item);
    else groups.set(key, [item]);
  });
  return [...groups.entries()];
};
